import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, UserRole } from '@/types';

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{ user: User; token: string }>
    ) => {
      console.log('[authSlice] setCredentials called with:', {
        user: action.payload.user,
        token: action.payload.token ? '***exists***' : null,
        role: action.payload.user?.role
      });
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.isLoading = false;
      state.error = null;
      console.log('[authSlice] State after setCredentials:', {
        isAuthenticated: state.isAuthenticated,
        userRole: state.user?.role,
        hasToken: !!state.token
      });
    },
    setUser: (state, action: PayloadAction<User>) => {
      console.log('[authSlice] setUser called with:', action.payload);
      state.user = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      console.log('[authSlice] setError called:', action.payload);
      state.error = action.payload;
      state.isLoading = false;
    },
    logout: (state) => {
      console.log('[authSlice] logout called');
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const { setCredentials, setUser, setLoading, setError, logout } =
  authSlice.actions;

// Selectors
export const selectCurrentUser = (state: { auth: AuthState }) => state.auth.user;
export const selectIsAuthenticated = (state: { auth: AuthState }) =>
  state.auth.isAuthenticated;
export const selectUserRole = (state: { auth: AuthState }): UserRole | null =>
  state.auth.user?.role ?? null;
export const selectAuthLoading = (state: { auth: AuthState }) =>
  state.auth.isLoading;

export default authSlice.reducer;
